import {
  ChangeDetectionStrategy,
  Component,
  inject,
  input,
  OnInit,
  ViewEncapsulation,
} from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { Store } from '@ngrx/store';

import { Order } from '../../../../models/order.model';
import { WidgetOrdersDisplayComponent } from '../../../../shared/components/widget-displays/widget-orders-display/widget-orders-display.component';
import {
  getActiveOrders,
  getOrdersLoading,
  getTotalActiveLocations,
  LoadOrders,
  State,
} from '../../../../store';

@Component({
  selector: 'app-ons-widget-orders',
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
  imports: [WidgetOrdersDisplayComponent],
  template: `
    <app-widget-orders-display
      class="dimensions-stretch"
      [hyperlink]="'/orders'"
      [loading]="isLoading()"
      [navigateOnClick]="navigateOnClick()"
      [orderCount]="totalOpenOrders()?.length"
      [locationCount]="totalActiveLocations()"
    ></app-widget-orders-display>
  `,
})
export class WidgetOrdersComponent implements OnInit {
  readonly navigateOnClick = input<boolean>(false);

  private readonly store = inject(Store<State>);

  readonly totalActiveLocations = toSignal<number>(
    this.store.select(getTotalActiveLocations),
  );

  readonly totalOpenOrders = toSignal<Order[]>(
    this.store.select(getActiveOrders),
  );

  readonly isLoading = toSignal<boolean>(this.store.select(getOrdersLoading));

  ngOnInit(): void {
    this.store.dispatch(new LoadOrders());
  }
}
